import axios from 'axios';

export default async function(url) {
  const response = await axios.get(url);
  return response.data;
}



// WEBPACK FOOTER //
// ./D:/node-prj/geoviewer2/src/services/getGeneric.js